import { Tag } from 'antd'
import type { CSSProperties, ReactNode } from 'react'

type Props = {
  children?: ReactNode
  style?: CSSProperties
}

/**
 * Unified "Soon" badge used across the app to mark features that are not yet
 * backed by real APIs. Matches the sidebar menu badge style.
 */
export const SoonTag = ({ children = 'Soon', style }: Props) => (
  <Tag
    color="warning"
    style={{
      marginInlineStart: 4,
      fontSize: 10,
      lineHeight: '16px',
      padding: '0 4px',
      ...style
    }}
  >
    {children}
  </Tag>
)
